export default __webpack_public_path__ + "static/media/healthicons_person-outline.c283e542.svg";